import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Text } from '@leroy-merlin-br/backyard-react-ui'

const wrapperIconStyles = () => css`
    label: wrapper;

    cursor: pointer;
`

const dividerStyles = ({ theme }) => css`
  label: divider;
  margin: ${theme.spacings.bit} 0;

  width: 15px;
  height: 2px;

  background: ${theme.colors.n200};
`

const textInfoStyles = ({ theme }) => css`
  label: text--info;
  color: ${theme.colors.n500};
`

export const WrapperIcon = styled('span')(wrapperIconStyles)
export const TextInfo = styled(Text)(textInfoStyles)
export const Divider = styled('div')(dividerStyles)
